'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pickup;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Pickup(props) {
  var city = props.city,
      components = props.components,
      country = props.country,
      exactLocation = props.exactLocation,
      location = props.location,
      time = props.time,
      t = props.t;
  var airportCode = props.airportCode;

  // airportCode optional prop

  airportCode = airportCode || '';

  var styleDropoffTitleLabel = (0, _emailStyleTools.textStyles)(components, 'DropOffTitleLabel');
  var styleDropoffValueLabel = (0, _emailStyleTools.textStyles)(components, 'DropOffValueLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'Pickup' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleDropoffTitleLabel },
            t('car.drop')
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleDropoffValueLabel },
            exactLocation
          )
        )
      ),
      airportCode && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleDropoffValueLabel },
            location,
            ' (',
            airportCode,
            ')'
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleDropoffValueLabel },
            city,
            ', ',
            country
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleDropoffValueLabel },
            time
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Active/DropOff.jsx
// module id = 1499
// module chunks = 0